import Home from '@/components/pages/Home'
import ContactUs from '@/components/pages/ContactUs'
import AboutUs from '@/components/pages/AboutUs'
import Voices from '@/components/pages/Voices'
import Library from '@/components/pages/Library'

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * NOTE: When adding new routes, due to an issue with the vue-prerender
 * plugin, the routes need to be manually added to build/build.js. In
 * there there is a list of URLs to pre-render on deployment.
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
*/
export default [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about-us/',
    name: 'about-us',
    component: AboutUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/voices-of-the-bereaved/',
    name: 'voices-of-the-bereaved',
    component: Voices,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/contact-us/',
    name: 'contact-us',
    component: ContactUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/lending-library/',
    name: 'lending-library',
    component: Library,
    pathToRegexpOptions: { strict: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js